<template>
  <footer>
    <div class="footer">
      <p>
        Made with ❤ by
        <a href="https://dtoledo.netlify.app/" target="_blank">
          Darrel Toledo
        </a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      //
    };
  },
};
</script>

<style>
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #42b983;
  color: white;
  text-align: center;
}
</style>
